export default __webpack_public_path__ + "static/media/user.e17f6e68.svg";